import moment from 'moment';
import { I18n } from 'react-redux-i18n';

export function extractOnlineSalesGroupData(list) {
  list.sort(
    (a, b) =>
      moment(a.date).diff(moment(b.date)) ||
      a.wine_name.localeCompare(b.wine_name) ||
      a.type.localeCompare(b.type)
  );

  const formattedData = {};

  for (let item of list) {
    const momentDate = moment(item.date, 'YYYY-MM-DD');
    const currentDate = momentDate.format('DD/MM/YYYY');

    let currentItem = formattedData[currentDate];

    if (!currentItem) {
      currentItem = {
        type: 'distribution',
        title: I18n.t('dashboard.feedTitles.onlineSales'),
        link: '/distribution/online-sales/overview',
        order: 5,
        date: momentDate.format('DD/MM/YYYY'),
        momentDate,
        descriptionList: [],
        types: {
          newSeller: {
            header: null,
            list: []
          },
          lowPrice: {
            header: null,
            list: []
          },
          highPrice: {
            header: null,
            list: []
          },
          notRespectedPrice: {
            header: null,
            list: []
          }
        }
      };

      const nbNewSeller = countItems(list, 'newSeller', item.date);
      const nbLowPrice = countItems(list, 'lowPrice', item.date);
      const nbHighPrice = countItems(list, 'highPrice', item.date);
      const nbNotRespectedPrice = countItems(
        list,
        'notRespectedPrice',
        item.date
      );

      if (nbNewSeller) {
        currentItem.types.newSeller.header = getFormattedHeaderDescription(
          nbNewSeller,
          'newSeller',
          currentDate
        );
      }

      if (nbLowPrice) {
        currentItem.types.lowPrice.header = getFormattedHeaderDescription(
          nbLowPrice,
          'lowPrice',
          currentDate
        );
      }

      if (nbHighPrice) {
        currentItem.types.highPrice.header = getFormattedHeaderDescription(
          nbLowPrice,
          'highPrice',
          currentDate
        );
      }

      if (nbNotRespectedPrice) {
        currentItem.types.notRespectedPrice.header =
          getFormattedHeaderDescription(
            nbNotRespectedPrice,
            'notRespectedPrice',
            currentDate
          );
      }
    }

    currentItem.types[item.type].list.push(getFormattedItemDescrition(item));
    formattedData[currentDate] = currentItem;
  }

  return Object.values(getFormattedDescription(formattedData));
}

function countItems(list, type, date) {
  return list.filter((item) => item.type === type && item.date === date).length;
}

function getFormattedHeaderDescription(nb, type) {
  return [nb, I18n.t('dashboard.onlineSales.' + type)].join('  ');
}

function getFormattedItemDescrition(item) {
  const currency = item.local_currency || 'EUR';
  const formattedPrice = Number(item.local_price).toLocaleString('fr-FR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  const evolColor = item.evolution > 0 ? '#6cc89f' : '#e25d34';

  return (
    <span style={{ display: 'inline-flex' }}>
      &nbsp;&nbsp;
      {[
        '-',
        item.store_name,
        '-',
        item.wine_name,
        item.vintage,
        I18n.t('at'),
        formattedPrice
      ].join(' ')}
      {item.type !== 'newSeller' && (
        <p style={{ color: evolColor }}>
          &nbsp;({(item.evolution * 100).toFixed(2)}%)
        </p>
      )}
    </span>
  );
}

function getFormattedDescription(data) {
  return Object.keys(data).map((date) => {
    Object.keys(data[date].types).forEach((type) => {
      const item = data[date].types[type];
      data[date].descriptionList.push({
        header: item.header,
        subList: item.list.slice(0, 3)
      });
    });

    return {
      type: data[date].type,
      title: data[date].title,
      link: data[date].link,
      order: data[date].order,
      date: data[date].date,
      momentDate: data[date].momentDate,
      descriptionList: data[date].descriptionList
    };
  });
}
